module.exports = __webpack_public_path__ + "static/img/autoLogin.1695199.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/autoLogin.jpg
// module id = gCG0
// module chunks = 159